import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { FiUpload } from 'react-icons/fi';

export const DragDropOverlay = ({
  isDragActive,
  title = 'Drop files to attach',
  description = 'Images, documents, and code files supported'
}) => {
  const theme = useTheme();

  if (!isDragActive) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none'
      }}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: `2px dashed ${theme.palette.primary.main}`,
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
          maxWidth: 400,
          mx: 2,
          boxShadow: theme.shadows[4]
        }}
      >
        <FiUpload
          size={48}
          style={{
            color: theme.palette.primary.main,
            marginBottom: theme.spacing(2)
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 600,
            mb: 1
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};
